import { VideoContentProps } from './type';

export const VideoContent = ({ children }: VideoContentProps) => <div className="relative h-full bg-black flex justify-center">{children}</div>;
